import { node } from "prop-types";
import { Fragment, forwardRef, useContext } from "react";

import { FnrToggle } from "UI/FnrToggle2";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap";
import {
  TabCustomHoverElement,
  TabCustomSelectedElement,
  tabToggleStyles,
} from "UI/tabBarStyles";

import { FnrTabsContext } from "./FnrTabs";
import Tab from "./Tab";

const Tabs = forwardRef(({ divider = null, ...props }, ref) => {
  const { tabs, padding } = useContext(FnrTabsContext);

  return (
    <FnrToggle
      ref={ref}
      style={{ paddingInline: `${padding}px`, ...tabToggleStyles }}
      allowOverflow
      CustomSelectedElement={TabCustomSelectedElement}
      CustomHoverElement={TabCustomHoverElement}
      padding={padding}
      {...props}
    >
      <FnrHorizontalGap gap={divider ? 8 : 24} wrap topAlign>
        {tabs.map(({ key, label, icon, amount, disabled }, idx) => (
          <Fragment key={key}>
            <Tab
              tabKey={key}
              label={label}
              icon={icon}
              amount={amount}
              disabled={disabled}
            />
            {tabs.length > idx + 1 && divider}
          </Fragment>
        ))}
      </FnrHorizontalGap>
    </FnrToggle>
  );
});

Tabs.propTypes = { divider: node };

export default Tabs;
